import { render, staticRenderFns } from "./topList.vue?vue&type=template&id=8df6d2b0&scoped=true&"
import script from "./topList.vue?vue&type=script&lang=js&"
export * from "./topList.vue?vue&type=script&lang=js&"
import style0 from "./topList.vue?vue&type=style&index=0&id=8df6d2b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df6d2b0",
  null
  
)

export default component.exports